import { QueryConstraint, Unsubscribe } from "firebase/firestore";

import FirestorePipe from "../utils/pipe";
import UsersHistory from "../entities/userHistory";


class UsersHistoryDB extends FirestorePipe {

  public static readonly colName = 'UsersHistory'

  constructor(idEstab: string) {
    if(!idEstab)
      throw new Error('Informe o id do estabelecimento')
    super(`${UsersHistoryDB.colName}`);
  }


  public create(data: UsersHistory): Promise<any> {
    return this._create(data);
  }
  public update(id: string, data: UsersHistory): Promise<any> {
    return this._update(id, data);
  }
  public delete(id: string): Promise<any> {
    return this._delete(id);
  }
  public getAll(...params: QueryConstraint[]): Promise<UsersHistory[]> {
    return this._getAll<UsersHistory>(...params);
  }
  public get(id: string): Promise<UsersHistory> {
    return this._get(id);
  }
  public on(listener: (data: UsersHistory[]) => void, ...params: QueryConstraint[]): Unsubscribe {
    return this._on(listener, ...params);
  }

}

export default UsersHistoryDB;